import { render } from "./Team.vue?vue&type=template&id=ac7d6c52&ts=true"
import script from "./Team.vue?vue&type=script&lang=ts"
export * from "./Team.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Work\\Picado\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__